import { createBrowserHistory } from 'history';
import { applyMiddleware, compose, createStore } from 'redux';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import thunkMiddleware from 'redux-thunk';
import loggerMiddleware from 'redux-logger';
import reducer from 'reducers';

const initialState = {};

export const history = createBrowserHistory();

export function configureStore() {
  return createStore(
    connectRouter(history)(reducer),
    initialState,
    compose(
      applyMiddleware(
        routerMiddleware(history),
        thunkMiddleware,
        loggerMiddleware
      )
    )
  );
};



// WEBPACK FOOTER //
// ./src/store.js